<a *ngIf="!MenuItem.OpenInNewTab && MenuItem.Url != null" [routerLink]="[MenuItem.Url]" (click)="TrackEvent(MenuItem.TelemetryIdentifier)">
	<span class="navbar-text">{{ MenuItem.Title }}</span>
</a>
<a *ngIf="MenuItem.OpenInNewTab && MenuItem.Url != null" [href]="MenuItem.Url" target="_blank" rel="noopener" (click)="TrackEvent(MenuItem.TelemetryIdentifier)">
	<span class="navbar-text">{{ MenuItem.Title }}</span>
</a>
<div *ngIf="MenuItem.Url == null" (click)="PerformClickAction(MenuItem)">
	<div class="nav-item-container">
		<span class="perform-action-navbar-text">{{ MenuItem.Title }}</span>
		<div *ngIf="IsLoadingOperation" class="loading-spinner"></div>
	</div>
</div>